// react
import { createContext, useContext } from 'react';

// api
import type { SessionResponse } from '@/api/auth-server/authServerApiSlice';

export interface SessionAuthContextValue {
  session: SessionResponse | undefined;
  isLoading: boolean;
  isAuthenticated: boolean;
  isAdmin: boolean;
}

export const SessionAuthContext = createContext<
  SessionAuthContextValue | undefined
>(undefined);

export function useSessionAuth() {
  const context = useContext(SessionAuthContext);

  const isAdmin =
    context?.session?.claims?.['accounts.superuser'] === 'True' || false;

  const email = context?.session?.claims?.email || '';

  if (!context) {
    throw new Error('useSessionAuth must be used within AuthProvider');
  }

  return {
    ...context,
    isAdmin,
    email,
  };
}
